<template>
  <el-dialog title="修改地址" :visible.sync="localVisible" width="500px" @close="handleClose" class="address-dialog">
    <AddAddressDialog :visible.sync="addAddressDialogVisible" :regionOptions="regionOptions" :editId="editId"
      @save="handleAddAddress" />
    <div v-for="(item, idx) in mySelfAddress" :key="item.id" class="address-item">
      <div class="address-header">
        <span class="name">{{ item.userName }}</span>
        <el-tag v-if="item.defaultFlag == 1" type="success" size="mini">默认</el-tag>
        <span class="phone">{{ item.phone }}</span>
        <el-button type="success" size="mini" @click="selectAddress(idx)">确定</el-button>
      </div>
      <div class="address-detail">{{ item.address }}</div>
      <div class="address-actions">
        <el-checkbox v-model="item.defaultFlag" :true-label="'1'" :false-label="'0'" @change="setDefault(item)">
          设为默认地址
        </el-checkbox>
        <el-link type="primary" @click="editAddress(item.id)">
          <i class="el-icon-edit"></i> 编辑
        </el-link>
        <el-link type="danger" @click="deleteAddress(item.id, idx)">
          <i class="el-icon-delete"></i> 删除
        </el-link>
      </div>
    </div>
    <div style="text-align:center;margin-top:20px;">
      <el-button type="success" @click="addAddress">+ 新增收货地址</el-button>
    </div>
  </el-dialog>
</template>

<script>
import AddAddressDialog from './addAddress.vue';
import { deleteAddress, setDefault, addressList } from '@/api/sjzx'
export default {
  props: {
    visible: Boolean,
    mySelfAddress: Array
  },
  data() {
    return {
      localVisible: this.visible,
      addAddressDialogVisible: false,
      regionOptions: [

      ],
      editId: null,
    }
  },

  components: {
    AddAddressDialog
  },
  mounted() {

  },
  methods: {
    // 关闭弹窗时触发，通知父组件关闭弹窗
    handleClose() {
      this.$emit('update:visible', false);
      //不能再这里清空数据，会与父组件默认地址逻辑冲突
      // if(this.mySelfAddress){
      //   this.$emit('select','');
      // }
    },
    // 选择某个地址，通知父组件选中，并关闭弹窗
    selectAddress(idx) {
      //确认地址
      console.log(idx, '查看idx')
      this.$emit('select', this.mySelfAddress[idx]);
      this.handleClose();
    },
    // 设置某个地址为默认地址，设置成功后刷新地址列表
    async setDefault(item) {
      let res = await setDefault({ id: item.id });
      if (res.code == 0) {
        await this.refreshAddressList();
      }
      if (this.mySelfAddress) {
        this.$emit('select', '');
      }
    },
    // 编辑地址，打开新增/编辑地址弹窗，并传递要编辑的id
    editAddress(id) {
      this.editId = id;
      this.addAddressDialogVisible = true;
    },
    // 删除地址，确认后调用接口，成功后刷新地址列表
    async deleteAddress(id, idx) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let res = await deleteAddress({ id });
        if (res.code == 0) {
          await this.refreshAddressList();
          this.$message({ type: 'success', message: '删除成功!' });
        } else {
          this.$message({ type: 'error', message: res.msg });
        }
      }).catch(() => {
        this.$message({ type: 'info', message: '已取消删除' });
      });
    },
    // 新增地址，打开新增/编辑地址弹窗
    addAddress() {
      this.editId = null;
      this.addAddressDialogVisible = true;
    },
    // 新增或编辑地址后，刷新地址列表，并关闭弹窗
    async handleAddAddress() {
      // 新增或编辑地址后，刷新列表
      await this.refreshAddressList();
      this.addAddressDialogVisible = false;
    },
    // 调用接口获取最新地址列表，并通过emit通知父组件更新mySelfAddress
    async refreshAddressList() {
      let res = await addressList();
      this.$emit('update:mySelfAddress', res.data.records || []);
    }
  },
  watch: {
    visible(val) {
      this.localVisible = val;
    },
    localVisible(val) {
      this.$emit('update:visible', val);
    }
  }
};
</script>

<style scoped>
.address-item {
  border-bottom: 1px solid #eee;
  padding: 12px 0;
}

.address-header {
  display: flex;
  align-items: center;
  gap: 10px;
}

.name {
  font-weight: bold;
}

.phone {
  margin-left: auto;
  color: #888;
}

.address-detail {
  color: #666;
  margin: 4px 0 8px 0;
}

.address-actions {
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: 14px;
}
</style>
